import React, { useEffect, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Banner from "./Components/Banner";
import Gig from "./Components/Gig";
import bannerImage from "./Resources/banner.jpg";

import NavigationBar from "./Components/NavigationBar";
import Container from "react-bootstrap/Container";

import CardGroup from "react-bootstrap/CardGroup";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import { FaPlusCircle } from "react-icons/fa";

import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  getDoc,
  doc,
} from "firebase/firestore";
import { db } from "./Config/firebase";
import { Timestamp } from "firebase/firestore";

import { GigProps } from "./Components/Gig";
import { AddGigModal } from "./Components/AddGigModal";

import { useAuth } from "./Components/Auth";
import { Card } from "react-bootstrap";

const ToStringDate = (date: Timestamp) => {
  const dateObject = date.toDate();
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric", // or '2-digit'
    month: "long", // 'short' for abbreviated month name or 'numeric' for number
    day: "numeric", // or '2-digit'
  };
  return dateObject.toLocaleDateString(undefined, options);
};

function App() {
  const { currentUser, userRole } = useAuth();

  const [gigs, setGigs] = useState<GigProps[]>([]);
  const [archivedGigs, setArchivedGigs] = useState<GigProps[]>([]);

  const getGigs = async () => {
    const now = new Date();
    now.setDate(now.getDate() - 4); //  minus a few days, to show current events
    const q = query(
      collection(db, "Gigs"),
      where("date", ">=", now),
      orderBy("date", "asc")
    );

    const querySnapshot = await getDocs(q);

    //const querySnapshot = await getDocs(collection(db, "Gigs"));
    const gigList: GigProps[] = querySnapshot.docs.map((doc): GigProps => {
      // Ensure the object conforms to the Gig type
      const data = doc.data() as GigProps; // Cast the document data to the Gig type
      return {
        id: doc.id,
        title: data.title,
        date: data.date,
        image: data.image,
        canEdit: false,
      };
    });
    setGigs(gigList);
  };

  const getArchivedGigs = async () => {
    const now = new Date();
    now.setDate(now.getDate() - 4); //  minus a few days, to show current events
    const q = query(
      collection(db, "Gigs"),
      where("date", "<", now),
      orderBy("date", "desc")
    );

    const querySnapshot = await getDocs(q);

    //const querySnapshot = await getDocs(collection(db, "Gigs"));
    const gigList: GigProps[] = querySnapshot.docs.map((doc): GigProps => {
      // Ensure the object conforms to the Gig type
      const data = doc.data() as GigProps; // Cast the document data to the Gig type
      return {
        id: doc.id,
        title: data.title,
        date: data.date,
        image: data.image,
        canEdit: false,
      };
    });
    setArchivedGigs(gigList);
  };

  useEffect(() => {
    getGigs();
    getArchivedGigs();
  }, []);

  const gigAdded = (title: String, date: Date, imagePath: string) =>
    void (
      {
        //TODO show new gig in the list
      }
    );

  return (
    <>
      <NavigationBar />
      <Banner pageTitle="Gigs" imageUrl={bannerImage} />
      <br />
      {userRole && userRole == "admin" ? (
        <Container>
          <CardGroup>
            <Card style={{ marginBottom: "15px" }}>
              <AddGigModal onSave={gigAdded} />
            </Card>
          </CardGroup>
        </Container>
      ) : null}
      <Tabs defaultActiveKey="home" id="fill-tab-example" className="mb-3" fill>
        <Tab eventKey="home" title="Upcoming Events">
          {gigs.map((item, index) => (
            <Container>
              <CardGroup>
                <Gig
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  date={item.date}
                  image={item.image}
                  canEdit={userRole && userRole == "admin" ? true : false}
                />
              </CardGroup>
            </Container>
          ))}
        </Tab>
        <Tab eventKey="profile" title="Past Events">
          {archivedGigs.map((item, index) => (
            <Container>
              <CardGroup>
                <Gig
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  date={item.date}
                  image={item.image}
                  canEdit={userRole && userRole == "admin" ? true : false}
                />
              </CardGroup>
            </Container>
          ))}
        </Tab>
      </Tabs>
    </>
  );
}

export default App;
